import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserDTO } from 'src/app/interfaces/base-entity';
import { StorageKeys } from 'src/app/enums/enums';
import { clearTenantContext } from 'src/app/utils/session-tenant-context.util';
import { normalizeSessionUser, SESSION_USER_STORAGE_KEY } from 'src/app/utils/session-user.util';
import { StorageService } from './storage.service';

export type TenantResolutionState = 'pending' | 'resolved';

@Injectable({
  providedIn: 'root'
})
export class SgsstAuthUserService {

  userLoggedIn$ = new BehaviorSubject<UserDTO | null>(
    normalizeSessionUser(
      this.storage.getItem(StorageKeys.CurrentUser, true) as UserDTO
    ) ?? null
  );

  /**
   * pending: aún no terminó checkUserAuth de esta sesión MSAL.
   * resolved: ya se aplicó (o limpió) el tenant desde API.
   */
  readonly tenantResolutionState$ = new BehaviorSubject<TenantResolutionState>('pending');

  constructor(private storage: StorageService) {}

  get isTenantResolutionPending(): boolean {
    return this.tenantResolutionState$.value === 'pending';
  }

  markTenantResolutionPending(): void {
    this.tenantResolutionState$.next('pending');
  }

  markTenantResolutionResolved(): void {
    this.tenantResolutionState$.next('resolved');
  }

  /** Limpia usuario/tenant de la app sin tocar el cache MSAL en localStorage. */
  clearAppSession(): void {
    clearTenantContext(this.storage);
    this.storage.remove(StorageKeys.CurrentUser);
    this.storage.remove(SESSION_USER_STORAGE_KEY);
    this.userLoggedIn$.next(null);
    this.markTenantResolutionResolved();
  }
}
